export default __webpack_public_path__ + "static/media/cs.85928ee7.jpg";